var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 z-50 flex items-center justify-center p-4 bg-gray-500 bg-opacity-75"},[_c('div',{staticClass:"p-4 rounded shadow-lg bg-gray-50"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }